<div [ngClass]="type" preventWindowUnloading class="message-toast">
  <ng-container [ngSwitch]="containsHtml">
    <p
      *ngSwitchCase="true"
      class="message"
      [innerHTML]="label | safe: 'html'"
    ></p>
    <p *ngSwitchDefault class="message">
      {{ label }}
    </p>
  </ng-container>

  <button type="button" class="close-action">
    <span class="sr-text">
      {{ 'ACTION.CLOSE' | translate }}
    </span>

    <app-icon [icon]="closeIcon"></app-icon>
  </button>
</div>
